import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLClaimsReportAdditionalFilter.metadata.json5';
import './MLClaimsReportAdditionalFilter.messages';

const MLClaimsReportAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData,
        claimStatusTypelist
    } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const [statusTypes, updateStatusTypes] = useState([]);

    useEffect(() => {
        const statusAvailableValues = claimStatusTypelist.codes.map((status) => {
            return {
                code: status.code,
                name: translator({
                    id: status.name,
                    defaultMessage: status.name
                })
            };
        });
        updateStatusTypes(statusAvailableValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onValueChange = (value) => {
        _.set(filterData, 'claimStatus_ML', value);
        updateFilterData(filterData);
        refreshData();
    }

    const overrideProps = {
        claimReportStatus: {
            availableValues: statusTypes,
            onValueChange,
            value: _.get(filterData, 'claimStatus_ML')
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
        />
    );
};

MLClaimsReportAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired,
    claimStatusTypelist: PropTypes.array.isRequired
};

export default MLClaimsReportAdditionalFilter;
